import { useMemo } from 'react';
export function getOverrides() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return keys.reduce(function (result, key) {
    result[key] = props[key] || {};
    return result;
  }, {});
}
export function useClasses(useStyles, classes) {
  for (var _len = arguments.length, props = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    props[_key - 2] = arguments[_key];
  }
  var styleClasses = useStyles.apply(void 0, props);
  return useMemo(function () {
    if (!classes) return styleClasses;
    return Object.keys(styleClasses).reduce(function (classNames, key) {
      var overrideClassName = classes[key];
      if (overrideClassName) classNames[key] = "".concat(styleClasses[key], " ").concat(overrideClassName);else classNames[key] = styleClasses[key];
      return classNames;
    }, {});
  }, [classes, styleClasses]);
}